import { Component, ViewChild, AfterViewInit, ViewEncapsulation, AfterContentInit, Output, EventEmitter, OnInit, NO_ERRORS_SCHEMA, Input, OnDestroy } from '@angular/core';
import { jqxDropDownButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownbutton';
import { jqxTreeComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxtree';
import { DanhMucService, UserService } from '../../services/index';
import { myJqxTreeItem } from 'app/model/tree';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-extracaythumuc',
  templateUrl: './extracaythumuc.component.html',
  styleUrls: ['./extracaythumuc.component.scss']
})
export class ExtracaythumucComponent implements AfterViewInit, AfterContentInit, OnDestroy {

  @Input() width: string = '100%';
  @Input() dropDownWidth: string = '450px';
  // 1 ghi vào SessionStorage, 0 không ghi
  @Input() treeDisabled: boolean = false;
  // dùng để gán combo hiện tại: nếu tendanhmuc == '' thì chọn mặc định thằng đầu tiên trong tree, còn kg thì gán text = tendanhmuc_hientai
  @Input() tendanhmuc_hientai: string = '';
  @Input() danhmucid_hientai: number = 0;
  @Output() selectedTree: EventEmitter<myJqxTreeItem> = new EventEmitter<myJqxTreeItem>();

  @ViewChild('dropDownTram') dropDownTram: jqxDropDownButtonComponent;
  @ViewChild('treeDienLucTram') treeDienLucTram: jqxTreeComponent;
  //@ViewChild('cboCtydl') cboCtydl: jqxComboBoxComponent;

  private lst_danhmuc: any[];
  public dltong: string;

  constructor(
    private DanhMucService: DanhMucService,
    private user: UserService
  ) { }


  public ngAfterViewInit(): void {
    //sessionStorage.setItem(environment.DsKhachHang, "");
    let dropDownTramSettings: jqwidgets.DropDownButtonOptions =
    {
      width: '100%',
      height: '25',
      dropDownWidth: '400'
    }
    this.dropDownTram.setOptions(dropDownTramSettings);

    let dropDownContent = "<span style='vertical-align: sub;'><img width='20' height='20' src='assets/img/loading.gif'/>    Vui lòng đợi...</sapn>";
    this.dropDownTram.setContent(dropDownContent);

    let treeSettings: jqwidgets.TreeOptions =
    {
      width: '400',
      height: "370px"
    }
    this.treeDienLucTram.setOptions(treeSettings);
    let user = this.user.getCurrentUser();
    this.getAllTram(user.danhmucid);
  }

  public ngAfterContentInit(): void {
    let currentUser = this.user.getCurrentUser();
    this.dltong = currentUser.tendanhmuc;
  }

  public ngOnDestroy() {
  }
  treeOnSelect(event: any): void {
    let item: any = this.treeDienLucTram.getSelectedItem();

    let item_detail = JSON.parse(item.value);

    let jqxitem = new myJqxTreeItem(item.label, item_detail.danhmucid, item_detail.loaidanhmuc, "", item_detail.meterid, item_detail.tendanhmuc, item_detail.code);
    this.selectedTree.emit(jqxitem);

    let dropDownContent = `<div style="position: relative; margin-left: 3px; margin-top: 4px;">${item.label}</div>`;
    this.dropDownTram.close();
    this.dropDownTram.setContent(dropDownContent);
  }


  treeOnExpand(event: any): void {
    this.treeDisabled = true;
    let item: any = this.treeDienLucTram.getItem(event.args.element);
    let item_detail = JSON.parse(item.value);

    if (item.nextItem.label == "<span><img width='20' height='20' src='assets/img/loading.gif'/></sapn>") {

      this.getSubNode(item_detail.danhmucid, item);
    }
    else {
      this.treeDisabled = false;
    }
  }

  private getAllTram(danhmucid: any) {

    let user = this.user.getCurrentUser();
    this.DanhMucService.getDanhmuc(danhmucid, "top", user.mataikhoan, 0).subscribe(response => {
      this.dropDownTram.setContent("");
      let listTram: any = JSON.parse(response);

      if (listTram.data.length > 0)
        listTram.data.forEach((item, index) => {

          item.value = JSON.stringify(item);



          let itemLoading: any = {
            danhmucid: "",
            danhmuccha: item.danhmucid,
            tendanhmuc: "<span><img width='20' height='20' src='assets/img/loading.gif'/></sapn>",
            loaidanhmuc: ""
          };
          if (item.danhmucid != danhmucid)
            listTram.data.push(itemLoading);
          item.id = item.id;
        });
      else {
        let itemNone: any = {
          danhmucid: "",
          danhmuccha: null,
          tendanhmuc: "Tài khoản chưa được phân quyền, vui lòng liên hệ người quản trị",
          loaidanhmuc: ""
        };
        listTram.data.push(itemNone);
      }
      // prepare the data
      let source =
      {
        datatype: "json",
        datafields: [
          { name: 'danhmucid' },
          { name: 'danhmuccha' },
          { name: 'tendanhmuc' },
          { name: 'loaidanhmuc' },
          { name: 'value' },
          { name: 'id' }
        ],
        localdata: listTram.data
      };

      let dataAdapter = new jqx.dataAdapter(source);
      dataAdapter.dataBind();
      let records = dataAdapter.getRecordsHierarchy('danhmucid', 'danhmuccha', 'items', [{ name: 'id', map: 'id' }, { name: 'tendanhmuc', map: 'label' }, { name: 'value', map: 'value' }, { name: 'loaidanhmuc', map: 'name' }]);

      this.lst_danhmuc = listTram.data;
      this.treeDienLucTram.clear();
      this.treeDienLucTram.source(records);


      let tendanhmuc = records[0].label;
      if (this.tendanhmuc_hientai != "")
        tendanhmuc = this.tendanhmuc_hientai;

    });

  }

  private getSubNode(danhmucid: any, parent: any) {
    let user = this.user.getCurrentUser();
    this.DanhMucService.getDanhmuc(danhmucid, "child", user.mataikhoan, 0).subscribe(response => {
      let listTram: any = JSON.parse(response);
      if (listTram.data.length == 0) {
        this.treeDienLucTram.removeItem(parent.nextItem);
        this.treeDisabled = false;
        return;
      }

      listTram.data.forEach((item, index) => {
        item.value = JSON.stringify(item);
        let itemLoading: any = {
          danhmucid: "",
          danhmuccha: item.danhmucid,
          tendanhmuc: "<span><img width='20' height='20' src='assets/img/loading.gif'/></sapn>",
          loaidanhmuc: ""
        };
        listTram.data.push(itemLoading);
        item.id = item.id;
      });
      // prepare the data
      let source =
      {
        datatype: "json",
        datafields: [
          { name: 'danhmucid' },
          { name: 'danhmuccha' },
          { name: 'tendanhmuc' },
          { name: 'loaidanhmuc' },
          { name: 'value' },
          { name: 'id' }
        ],
        localdata: listTram.data
      };

      let dataAdapter = new jqx.dataAdapter(source);
      dataAdapter.dataBind();
      let records = dataAdapter.getRecordsHierarchy('danhmucid', 'danhmuccha', 'items', [{ name: 'id', map: 'id' }, { name: 'tendanhmuc', map: 'label' }, { name: 'value', map: 'value' }, { name: 'loaidanhmuc', map: 'name' }]);
      this.treeDienLucTram.addTo(records, parent);

      this.treeDienLucTram.removeItem(parent.nextItem);

      this.treeDisabled = false;
    });

  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/extracaythumuc/extracaythumuc.component.ts